import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {useNavigate} from "react-router-dom";

import {CategoryTitle, EmblaCarousel, ProviderCard} from "@housebets/housebets-x-package";

import {EMBLA_OPTIONS} from "app/components/constants";
import {useProvidersData} from "./hooks/useProvidersData";
import {useLangNavigate} from "app/hooks/useLangNavigate";

export const Providers: React.FC = () => {
    const {$t} = useIntl();
    const navigate = useNavigate();
    const {providersData} = useProvidersData();
    const langNavigate = useLangNavigate();
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        setReady(true);
    }, []);

    return isReady ? (
        <EmblaCarousel
            title={<CategoryTitle icon="Providers" title={$t({id: "Providers"})} />}
            text={{
                viewAll: $t({id: "ViewAll"}),
            }}
            options={EMBLA_OPTIONS}
            partialSlides
            viewAll="/providers"
            viewAllClick={() => {
                navigate(langNavigate("/providers"));
            }}
            shadow
            navigation
            slides={providersData.map((item) => (
                <ProviderCard {...item} key={item.id} label={$t({id: "Games"})} to={langNavigate(`/providers/${item.id}`)} />
            ))}
        />
    ) : null;
};
